import { useCallback, useRef } from 'react'

import { ReportResponseRef } from './ReportResponseSheet'

export const useReportResponseSheet = () => {
  const reportResponseRef = useRef<ReportResponseRef>(null)

  const openReportResponseSheet = useCallback(() => {
    reportResponseRef.current?.openModal()
  }, [])

  const closeReportResponseSheet = useCallback(() => {
    reportResponseRef.current?.closeModal()
  }, [])

  return {
    reportResponseRef,
    closeReportResponseSheet,
    openReportResponseSheet
  }
}
